import {
  SCHEDULE_FORM_UPDATE,
  SCHEDULE_FORM_UPDATE_TIME_SLOT,
  SCHEDULE_FORM_UPDATE_REMOVE_TIME_SLOT,
  SCHEDULE_FORM_UPDATE_ADD_TIME_SLOT,
  SCHEDULE_FORM_SET_SCHEDULE,
  SCHEDULE_FORM_RESET,
} from '../../actions/scheduleForm';

import { POST_SCHEDULE, PUT_SCHEDULE } from '../../actions/events';

const initialState = {
  errors: [],
  posting: false,
  schedule: {
    description: '',
    settings: [
      {
        time: "12:00",
        low: 80,
        high: 100
      },
      {
        time: "22:00",
        low: 20,
        high: 80
      },
      {
        time: "06:00",
        low: 40,
        high: 100
      }
    ],
  },
}

const scheduleForm = (state = initialState, action) => {
  switch(action.type) {
    case `${POST_SCHEDULE}_PENDING`:
      return { ...state, posting: true }
    case `${POST_SCHEDULE}_REJECTED`:
      return { ...state, errors: ['an error accured'], posting: false }
    case SCHEDULE_FORM_SET_SCHEDULE:
      return { ...state, schedule: { ...action.schedule } };
    case SCHEDULE_FORM_UPDATE:
      return { ...state, schedule: { ...state.schedule, ...action.payload } };
    case SCHEDULE_FORM_UPDATE_ADD_TIME_SLOT:
      const { time, low, high } = action;
      return { ...state, schedule: { ...state.schedule, settings: [ ...state.schedule.settings, { time, low, high } ] } };
    case SCHEDULE_FORM_UPDATE_REMOVE_TIME_SLOT:
      return { ...state, schedule: { ...state.schedule, settings: state.schedule.settings.filter(timeslot => timeslot.time !== action.time) } };
    case SCHEDULE_FORM_UPDATE_TIME_SLOT:
      return { ...state, schedule: { ...state.schedule, settings: state.schedule.settings.map((timeslot) =>
        (timeslot.time === action.time) ? { ...timeslot, ...action.payload } : timeslot
      ) } };
    case `${PUT_SCHEDULE}_FULFILLED`:
    case `${POST_SCHEDULE}_FULFILLED`:
      return initialState
    case SCHEDULE_FORM_RESET:
      return initialState;
    default:
      return state;
  }
}

export default scheduleForm;



// WEBPACK FOOTER //
// ./src/reducers/ui/scheduleForm.js